import businessOwnerIcon from './business-owner-job-role.svg';
import salesIcon from './sales-job-role.svg';
import creatorIcon from './creator-job-role.svg';
import agencyIcon from './agency-job-role.svg';
import NAIcon from './not-applicable.svg';
import oneBanknoteIcon from './one-banknote-icon.svg';
import twoBanknoteIcon from './two-banknote-icon.svg';
import threeBanknoteIcon from './three-banknote-icon.svg';
import fiveBanknoteIcon from './five-banknote-icon.svg';
import lessThanFiveEmployeesIcon from './less-than-five-employees.svg';
import lessThanFiftyEmployeesIcon from './less-then-twenty-employees.svg';
import lessThanTwentyEmployeesIcon from './less-then-fifty-employees.svg';
import lessThanTwoHundredEmployeesIcon from './less-then-two-hundred-employees.svg';
import moreThanTwoHundredEmployeesIcon from './more-then-two-hundred-employees.svg';
import advertisingIndustryIcon from './advertising-industry.svg';
import agricultureIndustryIcon from './agriculture-industry.svg';
import coachIndustryIcon from './coach-industry.svg';
import influencerIndustryIcon from './influencer-industry.svg';
import eCommerceIndustryIcon from './eCommerce-industry.svg';
import educationIndustryIcon from './education-industry.svg';
import entertainmentIndustryIcon from './entertainment-industry.svg';
import eSportsIndustryIcon from './eSports-industry.svg';
import financialIndustryIcon from './financial-industry.svg';
import governmentIndustryIcon from './government-industry.svg';
import healthIndustryIcon from './health-industry.svg';
import insuranceIndustryIcon from './insurance-industry.svg';
import recruitmentIndustryIcon from './recruitment-industry.svg';
import legalIndustryIcon from './legal-industry.svg';
import marketplaceIndustryIcon from './marketplace-industry.svg';
import mediaIndustryIcon from './media-industry.svg';
import nonprofitIndustryIcon from './nonprofit-industry.svg';
import realEstateIndustryIcon from './real-estate-industry.svg';
import rehabIndustryIcon from './rehab-industry.svg';
import technologyIndustryIcon from './technology-industry.svg';
import securityIndustryIcon from './security-industry.svg';
import softwareIndustryIcon from './software-industry.svg';
import sportIndustryIcon from './sport-industry.svg';
import transportationIndustryIcon from './transportation-industry.svg';
import travelIndustryIcon from './travel-industry.svg';
import otherIcon from './other-industry.svg';
import appointmentBookingGoalIcon from './appointment-booking-goal.svg';
import automateLeadQualificationGoalIcon from './lead-qialification-goal.svg';
import marketingFunnelOptimizationGoalIcon from './marketing-funnel-optimization-goal.svg';
import searchLoopIcon from './search-loop-icon.svg';

export type OnboardingIcons =
  | JobRoleIcons
  | ClientChargeIcons
  | EmployeesCountIcons
  | AdBudgetIcons
  | IndustryIcons
  | GoalIcons;

export enum JobRoleIcons {
  ownBusiness = businessOwnerIcon,
  marketing = advertisingIndustryIcon,
  creator = creatorIcon,
  agency = agencyIcon,
  sales = salesIcon,
}

export enum ClientChargeIcons {
  NA = NAIcon,
  lessThenHundred = oneBanknoteIcon,
  lessThenTwoFifty = twoBanknoteIcon,
  lessThenFiveHundred = threeBanknoteIcon,
  moreThanFiveHundred = fiveBanknoteIcon,
}

export enum EmployeesCountIcons {
  lessThanFive = lessThanFiveEmployeesIcon,
  lessThanTwenty = lessThanTwentyEmployeesIcon,
  lessThanFifty = lessThanFiftyEmployeesIcon,
  lessThanTwoHundred = lessThanTwoHundredEmployeesIcon,
  moreThanTwoHundred = moreThanTwoHundredEmployeesIcon,
}

export enum AdBudgetIcons {
  noAdBudget = NAIcon,
  lessThenFifteenHundred = twoBanknoteIcon,
  lessThan10K = threeBanknoteIcon,
  moreThan10K = fiveBanknoteIcon,
}

export enum IndustryIcons {
  advertising = advertisingIndustryIcon,
  agriculture = agricultureIndustryIcon,
  coach = coachIndustryIcon,
  influencer = influencerIndustryIcon,
  eCommerce = eCommerceIndustryIcon,
  education = educationIndustryIcon,
  entertainment = entertainmentIndustryIcon,
  eSports = eSportsIndustryIcon,
  financial = financialIndustryIcon,
  government = governmentIndustryIcon,
  health = healthIndustryIcon,
  insurance = insuranceIndustryIcon,
  recruitment = recruitmentIndustryIcon,
  legal = legalIndustryIcon,
  marketplace = marketplaceIndustryIcon,
  media = mediaIndustryIcon,
  nonprofit = nonprofitIndustryIcon,
  realEstate = realEstateIndustryIcon,
  rehab = rehabIndustryIcon,
  technology = technologyIndustryIcon,
  security = securityIndustryIcon,
  software = softwareIndustryIcon,
  sport = sportIndustryIcon,
  transportation = transportationIndustryIcon,
  travel = travelIndustryIcon,
  other = otherIcon,
}

export enum GoalIcons {
  appointmentBooking = appointmentBookingGoalIcon,
  outboundLeadGen = agencyIcon,
  automateSocialPlatformSales = marketplaceIndustryIcon,
  automateLeadQualification = automateLeadQualificationGoalIcon,
  marketingFunnelOptimization = marketingFunnelOptimizationGoalIcon,
  findInfluencers = searchLoopIcon,
  other = otherIcon,
}
